import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import AppButton from '../../components/ui/AppButton';
import CompanyHistory from './components/companyHistory/CompanyHistory';
import CompanyList from './components/companyList/CompanyList';
import AdminEvaluation from './components/evaluation/AdminEvaluation';
import ManageCouponTab from './components/manage-coupon/ManageCouponTab';
import RewardManagement from './components/rewardManagement/RewardManagement';

const menus = [
  {
    label: 'รายชื่อบริษัททั้งหมด',
    value: 1,
  },
  {
    label: 'ประวัติการแลกรางวัล',
    value: 2,
  },
  {
    label: 'ประเมินความพอใจ',
    value: 3,
  },
  {
    label: 'จัดการของรางวัล',
    value: 4,
  },
  {
    label: 'การใช้คูปอง',
    value: 5,
  },
];

const AdminPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [tabActive, setTabActive] = useState(1);

  const handleTabChange = (idx) => {
    setTabActive(idx);
    navigate('/admin', { replace: true });
  };

  useEffect(() => {
    if (location.hash) {
      const newHash = location.hash.replace(/#/g, '');

      setTabActive(+newHash);
    }
  }, [location.hash]);

  return (
    <>
      <Helmet>
        <title>รายชื่อบริษัททั้งหมด | Caltex StarCard</title>
      </Helmet>

      <Box>
        <Box component="section" maxWidth="xl" mx="auto" sx={{ padding: '40px 1.25rem' }}>
          <Box
            sx={{
              width: '100%',
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(5, 1fr)',
              },
              alignItems: 'center',
              boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
              maxWidth: '1000px',
            }}
          >
            {menus.map((menu, index) => (
              <AppButton
                key={menu.value}
                variant="text"
                onClick={() => handleTabChange(menu.value)}
                sx={{
                  color: tabActive === menu.value ? 'white' : '#002B38',
                  backgroundColor: tabActive === menu.value ? '#002B38' : 'white',
                  borderRadius: 0,
                  borderTopLeftRadius: {
                    xs: index === 0 ? '10px' : 0,
                  },
                  borderTopRightRadius: {
                    xs: index === 0 ? '10px' : 0,
                    sm: index === 4 ? '10px' : 0,
                  },
                  py: 1,
                  px: 2.5,
                  height: '100%',

                  fontSize: {
                    xs: '1rem',
                    sm: '1.125rem',
                    md: '1.25rem',
                  },

                  '&:hover': {
                    color: 'white',
                    backgroundColor: '#002B38',
                  },
                }}
              >
                {menu.label}
              </AppButton>
            ))}
          </Box>

          {tabActive === 1 && <CompanyList />}
          {tabActive === 2 && <CompanyHistory />}
          {tabActive === 3 && <AdminEvaluation />}
          {tabActive === 4 && <RewardManagement />}
          {tabActive === 5 && <ManageCouponTab />}
        </Box>
      </Box>
    </>
  );
};

export default AdminPage;
